export default (state={}, action) => {
  switch(action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/core/dashboard/reducer.js